import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Injector, OnInit, PLATFORM_ID } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { setTitle } from '@layout/layout.store';
import { Store } from '@ngrx/store';
import { NzModalService } from 'ng-zorro-antd/modal';
import { MatomoInjector } from 'ngx-matomo-v9';
import { filter } from 'rxjs/operators';
import { resetUrl } from '@shared/util';
import { BasicConfigService } from './core/service/basicConfig.service';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`
})
export class AppComponent implements OnInit {
  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: Object,
    private readonly matomoInjector: MatomoInjector,
    private readonly store: Store,
    private readonly router: Router,
    private readonly title: Title,
    private readonly injector: Injector,
    private readonly modalSrv: NzModalService,
    private readonly configService: BasicConfigService
  ) {
    const url: string = window.location.href;
    if (url && url.includes('esurfing')) {
      this.configService.setConfig('CustonMadeConfig', { openBy: 'BestPay', XencioIcon: 'show' });
      const InfoDeploy = {
        XENCIO: '见知',
        systemName: '多银行资金系统',
        xencioBox: '银企通服务',
        xencioSupportTeam: '见知支持团队',
        xencioCustomer: '见知客服'
      };
      this.configService.setConfig('InfoDeploy', InfoDeploy);
    }
  }

  ngOnInit() {
    if (
      isPlatformBrowser(this.platformId) &&
      this.configService.get('PIWIK_URL') &&
      this.configService.get('PIWIK_SITE_ID')
    ) {
      // Matomo
      this.matomoInjector.init(this.configService.get('PIWIK_URL'), this.configService.get('PIWIK_SITE_ID'));
    }
    /**index.html引导进来的url进行重写**/
    if (window.location.href.indexOf('index.html?t=') > -1) {
      resetUrl();
    }
    let pathname = window.location.pathname;
    if (pathname.includes('xencio_en')) {
      localStorage.NG_TRANSLATE_LANG_KEY = 'en';
    } else {
      localStorage.NG_TRANSLATE_LANG_KEY = 'cn';
    }
    let LANG = localStorage.NG_TRANSLATE_LANG_KEY === 'en' ? 'EN' : 'CN';
    this.router.events.pipe(filter(evt => evt instanceof NavigationEnd)).subscribe((evt: NavigationEnd) => {
      // 设置标题
      let next = this.injector.get(ActivatedRoute);
      while (next.firstChild) {
        next = next.firstChild;
      }
      const data = (next.snapshot && next.snapshot.data) ?? {};

      this.title.setTitle([data.title, this.configService.get(`NAME_${LANG}`)].join(' - '));
      this.store.dispatch(
        setTitle({
          title: data.title,
          hideContentTitle: !!data.hideContentTitle,
          fullCurrency: data.fullCurrency ?? false
        })
      );
      // this.modalSrv.closeAll(); // 此代码目的是在切换菜单时默认关闭所有model弹窗，但目前产品上不存在有弹窗的情况下可以切换菜单
    });

    this.title.setTitle(this.configService.get(`NAME_${LANG}`));

    const style = document.createElement('link');
    style.type = 'text/css';
    style.rel = 'stylesheet';
    style.id = 'bank-css';
    style.href = 'assets/styles/bank-icon.component.css';
    const head = document.getElementsByTagName('head')[0];
    head.appendChild(style);
  }
}
